import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  QUICK_RANGES,
  computeQuickRange,
  loadKanbanDateFilter,
  saveKanbanDateFilter,
} from "../../../utils/dateRanges";

// Props:
// - onChange({ startDate, endDate, activeRange })
// - defaultRangeKey (opcional)
export function KanbanDateFilter({ onChange, defaultRangeKey = "last7" }) {
  const persisted = useMemo(() => loadKanbanDateFilter(), []);

  const initial = useMemo(() => {
    // si hay persisted, úsalo; si no, usa el defaultRangeKey
    if (persisted?.startDate || persisted?.endDate) return persisted;

    const { startDate, endDate } = computeQuickRange(defaultRangeKey);
    return {
      activeRange: defaultRangeKey,
      startDate,
      endDate,
    };
  }, [persisted, defaultRangeKey]);

  const [startDate, setStartDate] = useState(initial.startDate);
  const [endDate, setEndDate] = useState(initial.endDate);
  const [activeRange, setActiveRange] = useState(initial.activeRange);

  // persist + notificar al padre
  useEffect(() => {
    const payload = { startDate, endDate, activeRange };
    saveKanbanDateFilter(payload);
    onChange?.(payload);
  }, [startDate, endDate, activeRange, onChange]);

  const handleClickRange = (key) => {
    const r = computeQuickRange(key);
    setStartDate(r.startDate);
    setEndDate(r.endDate);
    setActiveRange(key);
  };

  const handleManualChange = ([start, end]) => {
    setStartDate(start ?? null);
    setEndDate(end ?? null);
    setActiveRange(null); // manual
  };

  const clear = () => {
    setStartDate(null);
    setEndDate(null);
    setActiveRange(null);
  };

  return (
    <div className="row-sb justify-content-between align-items-center">
      <div className="button-dashboard mr-3">
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={handleManualChange}
          dateFormat="dd/MM/yyyy"
          placeholderText="Selecciona un rango"
        />

        {Object.entries(QUICK_RANGES).map(([key, { label }]) => (
          <button
            key={key}
            type="button"
            className={activeRange === key ? "active" : ""}
            onClick={() => handleClickRange(key)}
          >
            {label}
          </button>
        ))}

        <button type="button" onClick={clear}>
          Limpiar
        </button>
      </div>
    </div>
  );
}
